/*
  Motiv-Auswahl der Ornamente (snippets/ornamente-motiv.liquid, Vorlage product.ornamentetiere).
  1) Reihenfolge: Die Auswahl rückt im teeinblue-Formular hinter die Formwahl (erst Form, dann Motiv).
  2) Motiv-Wechsel: Jedes Motiv ist ein eigenes Produkt. Beim Wechsel wandern die gewählte Form,
     Anzahl, Wunschnamen, eigene Formen je Ornament und die Stelle auf der Seite mit, damit es wie
     eine Auswahl auf derselben Seite wirkt.
*/
(() => {
  const box = document.querySelector('[data-omotiv]');
  if (!box) return;

  const WECHSEL = 'omotiv-wechsel';
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const anker = document.querySelector('[data-omotiv-anker]');
  const home = box.parentElement;
  const formOption = () => document.querySelector('form.tee-form-wrapper .tee-option--color');
  const textInputs = () => [...document.querySelectorAll('form.tee-form-wrapper .tee-field--text input[type="text"]')];
  const formValue = () => (document.querySelector('form.tee-form-wrapper .tee-option--color input:checked') || {}).value || null;
  const sichtbar = () => box.getClientRects().length > 0;

  // ---------- Platz: direkt hinter der Formwahl von teeinblue ----------
  // teeinblue baut das Formular erst nach dem Laden auf und bei einem Formwechsel teils neu,
  // deshalb bei jeder Änderung prüfen, ob die Auswahl noch an ihrem Platz sitzt.
  // nicht mehr angebotene Formen (data-ohne-formen) ausblenden; ist eine davon gewählt (alter Link mit
  // ?variant=…), auf die erste angebotene Form wechseln
  const OHNE = (box.dataset.ohneFormen || '').split(',').map((s) => s.trim()).filter(Boolean);
  let formWechsel = false;
  function ohneFormen(option) {
    if (!OHNE.length) return;
    const radios = [...option.querySelectorAll('input[type="radio"]')];
    radios.forEach((i) => {
      const w = i.closest('.tee-radio') || i.parentElement;
      if (w && OHNE.includes(i.value) && !w.classList.contains('omotiv-weg')) w.classList.add('omotiv-weg');
    });
    const gewaehlt = radios.find((i) => i.checked);
    if (!gewaehlt || !OHNE.includes(gewaehlt.value) || formWechsel) return;
    const erste = radios.find((i) => !OHNE.includes(i.value));
    const label = erste && ((erste.id && option.querySelector(`label[for="${CSS.escape(erste.id)}"]`)) || erste);
    if (!label) return;
    formWechsel = true;
    label.click();
    setTimeout(() => { formWechsel = false; }, 1500);
  }

  function place() {
    const option = formOption();
    if (!option) return false;
    ohneFormen(option);
    if (option.nextElementSibling !== box) option.insertAdjacentElement('afterend', box);
    box.classList.remove('is-fallback');
    box.classList.add('is-placed');
    return true;
  }
  place();
  new MutationObserver(place).observe(home, { childList: true, subtree: true });
  // Ausweichlösung: kommt das Formular nicht, bleibt die Auswahl oben über dem Formular
  setTimeout(() => { if (!box.classList.contains('is-placed')) box.classList.add('is-fallback'); }, 5000);

  // ---------- Motiv-Wechsel ----------
  function takeWechsel() {
    try {
      const raw = sessionStorage.getItem(WECHSEL);
      if (!raw) return null;
      sessionStorage.removeItem(WECHSEL);
      const s = JSON.parse(raw);
      return s && Date.now() - s.t < 10 * 60 * 1000 ? s : null;
    } catch (e) { return null; }
  }
  const wechsel = takeWechsel();
  // die Mengen-Auswahl (assets/ornamente-set.js) übernimmt daraus Anzahl und Namen
  window.ornamenteWechsel = wechsel;

  // gleiche Form wie jetzt, falls es sie beim neuen Motiv gibt, sonst dessen erste Form
  function motivUrl(a) {
    // mit Mengen-Auswahl: die oben für alle gewählte Form, nicht die des gerade gezeigten Ornaments
    const set = window.ornamenteSet && window.ornamenteSet.zustand();
    const form = (set && set.basis) || formValue();
    if (!form) return a.href;
    const ids = Object.fromEntries((a.dataset.formen || '').split('|').filter(Boolean).map((p) => p.split('=')));
    return ids[form] ? `${a.dataset.url}?variant=${ids[form]}` : a.dataset.url;
  }

  box.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-handle]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    if (a.classList.contains('is-on')) return;
    try {
      const set = window.ornamenteSet && window.ornamenteSet.zustand();
      sessionStorage.setItem(WECHSEL, JSON.stringify({
        t: Date.now(),
        top: Math.round(box.getBoundingClientRect().top),
        ankerTop: anker ? Math.round(anker.getBoundingClientRect().top) : null,
        qty: set ? set.qty : 1,
        texte: set ? set.namen : textInputs().map((i) => i.value),
        formen: set ? set.formen : []
      }));
    } catch (err) { /* ohne Speicher klappt der Wechsel trotzdem, nur ohne Übernahme */ }
    a.classList.add('is-loading');
    window.location.href = motivUrl(a);
  });
  // zurück über den Browser-Knopf: Kachel nicht blass stehen lassen
  window.addEventListener('pageshow', () => {
    box.querySelectorAll('.is-loading').forEach((a) => a.classList.remove('is-loading'));
  });

  if (!wechsel) return;

  // Nach dem Wechsel: Seite wieder an die Stelle der Motiv-Auswahl rücken. Solange teeinblue das
  // Formular noch aufbaut, an der Marke über dem Formular ausrichten, danach an der Auswahl selbst.
  // Die Galerie darüber lädt noch nach, deshalb kurz nachführen, bis der Kunde selbst scrollt oder tippt.
  if (typeof wechsel.top === 'number') {
    let stop = false;
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((ev) => {
      window.addEventListener(ev, () => { stop = true; }, { once: true, passive: true });
    });
    const align = () => {
      let d = 0;
      if (sichtbar()) d = box.getBoundingClientRect().top - wechsel.top;
      else if (anker && typeof wechsel.ankerTop === 'number') d = anker.getBoundingClientRect().top - wechsel.ankerTop;
      if (Math.abs(d) > 2) window.scrollBy({ top: d, behavior: 'instant' });
    };
    align();
    (async () => {
      let nachPlatz = 0;
      for (let i = 0; i < 40 && nachPlatz < 12 && !stop; i++) {
        await sleep(250);
        if (stop) break;
        align();
        if (sichtbar()) nachPlatz++;
      }
    })();
  }

  // Wunschname übernehmen, sobald teeinblue das Formular aufgebaut hat. Mit Mengen-Auswahl auf der
  // Seite macht das assets/ornamente-set.js (Anzahl + alle Namen).
  const texte = (wechsel.texte || []).map((t) => String(t || '').trim());
  if (texte.some(Boolean) && !document.querySelector('[data-oset]')) {
    (async () => {
      for (let i = 0; i < 60; i++) {
        const inputs = textInputs();
        if (inputs.length) {
          inputs.forEach((inp, n) => {
            const max = inp.maxLength > 0 ? inp.maxLength : 100;
            const text = (texte[n] || '').slice(0, max);
            if (!text || inp.value) return;
            inp.value = text;
            inp.dispatchEvent(new Event('input', { bubbles: true }));
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return;
        }
        await sleep(250);
      }
    })();
  }
})();
